import * as fuzz from 'fuzzball'

export function pluralizeFromNumber(len: number): string {
  if (len === 0) {
    return 's'
  }

  return len > 1 ? 's' : ''
}

export function pluralize(items: string | any[]): string {
  if (!items) return ''
  const len = items.length

  return pluralizeFromNumber(len)
}

export function naturalJoin(wordList: string[]): string {
  // return human readable string list: planes, trains and automobiles
  if (!wordList.length) return ''
  if (wordList.length < 3) return wordList.join(' and ')

  return [wordList.slice(0, -1).join(', '), wordList[wordList.length - 1]].join(' and ')
}
// sorted - if the string list should be maintained in a sorted order (for cases where honestly we should be using a set but this is cheaper)
export function addToStringList(strList: string, keyToAdd: string, sorted?: true): string {
  let intermediate = strList
    .split(',')
    .concat(keyToAdd)
    .filter(k => k)

  if (sorted) {
    intermediate = intermediate.sort()
  }

  return intermediate.join(',')
}
export function removeFromStringList(strList: string, keyToRemove: string): string {
  return strList
    .split(',')
    .filter(k => k)
    .filter(k => k !== keyToRemove)
    .join(',')
}

export function findGoodFuzzyMatch(query: string, choices: string[]): string {
  if (!query) {
    return undefined
  }

  // fuzz.partial_ratio - so that searching for "22001-El Segundo Bookstore" will match 100% with "El Segundo Bookstore"
  const fuzzResults = fuzz.extract(query.toLowerCase(), choices, { scorer: fuzz.partial_ratio })

  const firstGoodResult = fuzzResults.find(result => {
    const [, matchRating, _matchArrayIdx] = result
    return matchRating > 90
  })

  return firstGoodResult && firstGoodResult[0]
}

export const stringToBool = str => str === 'true'
